import { render, staticRenderFns } from "./ModalProfile.vue?vue&type=template&id=5649e676&scoped=true&"
import script from "./ModalProfile.vue?vue&type=script&lang=js&"
export * from "./ModalProfile.vue?vue&type=script&lang=js&"
import style0 from "./ModalProfile.vue?vue&type=style&index=0&id=5649e676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5649e676",
  null
  
)

export default component.exports